(() => {
  let observer;
  const setup = () => {
    const nav = document.querySelector('.bhq-store > .bhq-nav');
    if (!nav) return;
    if (observer) observer.disconnect();
    const measure = () => {
      const height = Math.ceil(nav.getBoundingClientRect().height) + 'px';
      document.documentElement.style.setProperty('--bhq-nav-height', height);
      document.body.style.setProperty('--header-height', height);
      document.body.style.setProperty('--header-group-height', height);
    };
    measure();
    observer = new ResizeObserver(measure);
    observer.observe(nav);
    if (document.fonts) document.fonts.ready.then(measure);
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
